import { Box } from '@rbilabs/universal-components';

export const CloseButtonWrapper = Box.withConfig({ position: 'absolute', right: '$4' });
